import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import { HomeComponent } from './home/home.component';
import {FormsModule, ReactiveFormsModule}  from '@angular/forms';
import { EmailValidatorDirective } from './directives/email-validator.directive';
import { MobileValidatorDirective } from './directives/mobile-validator.directive';
import { PasswordValidatorDirective } from './directives/password-validator.directive';
import { NameValidatorDirective } from './directives/name-validator.directive';
import { ChatpageComponent } from './chatpage/chatpage.component';
import { ContactComponent } from './contact/contact.component';
import { MessageComponent } from './message/message.component';
import { OnlineUserComponent } from './online-user/online-user.component';
import { ChatFilterPipe } from './pipes/chat-filter.pipe';
import { UserNamePipe } from './pipes/user-name.pipe';;

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    RegisterComponent,
    HomeComponent,
    EmailValidatorDirective,
    MobileValidatorDirective,
    PasswordValidatorDirective,
    NameValidatorDirective,
    ChatpageComponent,
    ContactComponent,
    MessageComponent,
    OnlineUserComponent,
    ChatFilterPipe,
    UserNamePipe
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
